import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";
import { parseAnalysisStream } from "../utils/parseAnalysisStream";



const analyzeLogFile = async ({
  tcid,
  description,
  testcasename,
  errorstep,
  checktillsteps, 
  option,
  action = "analyzeLogFile",
}) => {
  const user = getUserDetails();

const params = new URLSearchParams({
    action,
    companyId: user.companyid,
    tcid,
  });
  if (description != null) params.append("description", description);
  if (testcasename != null) params.append("testcasename", testcasename);
  if (errorstep != null) params.append("errorstep", errorstep);
  if (checktillsteps != null) params.append("checktillsteps", checktillsteps);
   if (option != null) params.append("option", option);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${params.toString()}`
  );
  return parseAnalysisStream(response.data?.analysis);
};

const useAnalyzeReportQuery = ({
  tcid,
  description,
  testcasename,
  errorstep,
  checktillsteps,
  option,
}) => {
  return useQuery({
    queryKey: [
      "analyzeReport",
      tcid,
      description,
      testcasename,
      errorstep,
      checktillsteps,
      option,
    ],
    queryFn: () =>
      analyzeLogFile({ tcid, description, testcasename, errorstep, checktillsteps, option }),
    enabled: !!tcid,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  });
};

export default useAnalyzeReportQuery;